/* eslint-disable */
export default {
  removeParticipant: 'Remover participante',
  confirmStr1: 'Tem a certeza de que pretende remover',
  confirmStr2: 'desta chamada?',
  remove: 'Remover',
  cancel: 'Cancelar',
  participants: 'Participantes',
  participant: 'Participante',
  conferenceCall: 'Chamada de conferência',
  unknownNumber: 'Anónimo',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
